
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fair",
      function () {
        return require("private-next-pages/fair.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fair"])
      });
    }
  